import { render, staticRenderFns } from "./sso-footer.vue?vue&type=template&id=ed84f8ce&scoped=true"
import script from "./sso-footer.vue?vue&type=script&lang=js"
export * from "./sso-footer.vue?vue&type=script&lang=js"
import style0 from "./sso-footer.vue?vue&type=style&index=0&id=ed84f8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed84f8ce",
  null
  
)

export default component.exports